import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Privacy Policy</h1>
      <div style={styles.content}>
        <p>
          Welcome to the Privacy Policy for OOTD.ai operated by Starforge PTE.
          LTD. ("Company"). We are committed to protecting your personal
          information and your right to privacy.
        </p>
        <p>
          If you have any questions or concerns about our policy, or our
          practices with regards to your personal information, please contact us
          at privacy@ootd.ai.
        </p>

        <h2 style={styles.subheader}>Information We Collect</h2>
        <p>
          We collect personal information that you provide to us such as name,
          address, contact information, passwords and security data, and payment
          information. We collect personal information that you voluntarily
          provide to us when registering at the App, expressing an interest in
          obtaining information about us or our products and services, when
          participating in activities on the App or otherwise contacting us.
        </p>

        <h2 style={styles.subheader}>How We Use Your Information</h2>
        <p>
          We use personal information collected via our App for a variety of
          business purposes described below. We process your personal
          information for these purposes in reliance on our legitimate business
          interests, in order to enter into or perform a contract with you, with
          your consent, and/or for compliance with our legal obligations.
        </p>
        <ul>
          <li>To facilitate account creation and logon process.</li>
          <li>To send administrative information to you.</li>
          <li>To fulfill and manage your orders.</li>
          <li>To post testimonials.</li>
        </ul>

        <h2 style={styles.subheader}>Sharing Your Information</h2>
        <p>
          We only share information with your consent, to comply with laws, to
          provide you with services, to protect your rights, or to fulfill
          business obligations.
        </p>

        <h2 style={styles.subheader}>Retention of Your Data</h2>
        <p>
          We will only keep your personal information for as long as it is
          necessary for the purposes set out in this privacy policy, unless a
          longer retention period is required or permitted by law.
        </p>

        <h2 style={styles.subheader}>Data Protection Rights</h2>
        <p>
          You have the right to request access, correction, amendments, or
          deletions of your personal information. If you wish to exercise these
          rights, please contact us at privacy@ootd.ai.
        </p>

        <h2 style={styles.subheader}>Transfer of Data</h2>
        <p>
          Your information, including personal data, may be transferred to — and
          maintained on — computers located outside of your state, province,
          country or other governmental jurisdiction where the data protection
          laws may differ from those of your jurisdiction.
        </p>

        <h2 style={styles.subheader}>Updates to Our Privacy Policy</h2>
        <p>
          We may update this privacy policy from time to time. The updated
          version will be indicated by an updated "Revised" date and the updated
          version will be effective as soon as it is accessible.
        </p>

        <h2 style={styles.subheader}>Contact Us</h2>
        <p>
          If you have questions or comments about this policy, you may email us
          at privacy@ootd.ai.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    maxWidth: "800px",
    margin: "0 auto",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
  },
  header: {
    textAlign: "center",
    marginBottom: "20px",
  },
  subheader: {
    marginTop: "20px",
  },
  content: {
    textAlign: "justify",
  },
};

export default PrivacyPolicy;
